import dayjs from 'dayjs'
import zipObject from 'lodash/zipObject'
import { generateStartDate } from 'components/forms/auth-schedule-form/ScheduleStartDate'

export default {
    granulaizeSlots(slots, length) {
        return slots.reduce(
            (granules, { from, to }) =>
                granules.concat(
                    Array((to - from) / length)
                        .fill([])
                        .map((value, index) => [from + index * length, from + (index + 1) * length])
                        .map(([from, to]) => [
                            dayjs().startOf('day').add(from, 'minutes').format('HH:mm'),
                            dayjs().startOf('day').add(to, 'minutes').format('HH:mm'),
                        ]),
                ),
            [],
        )
    },

    transformAvailability(days, appointmentLength) {
        return zipObject(
            ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'],
            days.map((daySlots) => this.granulaizeSlots(daySlots, appointmentLength)),
        )
    },

    transform(data, practiceId) {
        return Object.keys(data).reduce((locationSchedules, practiceLocationId) => {
            const {
                [practiceLocationId]: { frequency: repeat, days: availability, appointmentLength, id, startWeekDate },
            } = data
            if (availability?.findIndex((slots) => slots.length > 0) === -1) {
                return locationSchedules
            }

            return locationSchedules.concat([
                {
                    id: id,
                    practiceId: parseInt(practiceId),
                    practiceLocationId: practiceLocationId === '0' ? undefined : parseInt(practiceLocationId),
                    slots: this.transformAvailability(availability, appointmentLength),
                    startWeekDate: startWeekDate || generateStartDate(repeat).format('YYYY-MM-DD'),
                    appointmentLength,
                    repeat,
                },
            ])
        }, [])
    },
}
